import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const deliveryApprovalActions = {
  SET_DELIVERY_APPROVAL_DATA: 'SET_DELIVERY_APPROVAL_DATA',
  SET_IS_FETCHING_DELIVERY_APPROVAL_DATA:
    'SET_IS_FETCHING_DELIVERY_APPROVAL_DATA',
  SET_ACTION_DELIVERY_IN_PROGRESS: 'SET_ACTION_DELIVERY_IN_PROGRESS'
};

const setDeliveryApprovaldData = payload => {
  return {
    type: deliveryApprovalActions.SET_DELIVERY_APPROVAL_DATA,
    payload: payload
  };
};

const setIsFetchingDeliveryApprovalData = payload => {
  return {
    type: deliveryApprovalActions.SET_IS_FETCHING_DELIVERY_APPROVAL_DATA,
    payload: payload
  };
};

const setActionDelivery = payload => {
  return {
    type: deliveryApprovalActions.SET_ACTION_DELIVERY_IN_PROGRESS,
    payload: payload
  };
};

export const approveOrRejectDelivery = (data, entityType) => dispatch => {
  console.log(data);
  dispatch(setActionDelivery(true));
  const param = [
    { key: '{cnote}', val: data.cnote },
    { key: '{isApproved}', val: data.isApproved }
  ];

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'deliveryApprovalAction',
    pathVariables: param,
    method: 'PUT',
    successCb: res => {
      dispatch(setActionDelivery(false));
      if (res.status === 'SUCCESS') {
        toastr.success('Action completed successfully');
        dispatch(getDeliveryApprovalData(entityType));
      } else if (res.status === 'FAILURE') {
      }
    },
    failureCb: res => {
      dispatch(setActionDelivery(false));
    },
    catchCb: res => {
      dispatch(setActionDelivery(false));
    }
  };
  makeApiCall(requestObj);
};

export const bulkApproveOrRejectDelivery = (
  cnotes,
  isApproved,
  entityType,
  callback
) => dispatch => {
  dispatch(setActionDelivery(true));

  const numberOfCnotes = (cnotes || []).length || 0;
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bulkDeliveryApprovalAction',
    data: {
      cnotes: cnotes || [],
      isApproved
    },
    method: 'PUT',
    successCb: res => {
      dispatch(setActionDelivery(false));
      if (res.status === 'SUCCESS') {
        toastr.success(
          'Success',
          isApproved
            ? 'Successfully Approved ' + numberOfCnotes + ' Consignments'
            : 'Successfully Rejected ' + numberOfCnotes + ' Consignments'
        );
        dispatch(getDeliveryApprovalData(entityType, callback));
      } else if (res.status === 'FAILURE') {
        toastr.error('Error', 'Something went wrong');
      }
    },
    failureCb: res => {
      dispatch(setActionDelivery(false));
      toastr.error('Error', 'Something went wrong');
    },
    catchCb: res => {
      dispatch(setActionDelivery(false));
      toastr.error('Error', 'Something went wrong');
    }
  };
  makeApiCall(requestObj);
};

export const getDeliveryApprovalData = (entityType, callback) => dispatch => {
  dispatch(setIsFetchingDeliveryApprovalData(true));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'deliveryApproval',
    replaceParamsArr: [{ key: 'entityType', val: entityType }],
    successCb: res => {
      dispatch(setIsFetchingDeliveryApprovalData(false));
      if (res.status === 'SUCCESS') {
        dispatch(setDeliveryApprovaldData(res.payload || []));
        if (callback) {
          callback(res.payload);
        }
      } else if (res.status === 'FAILURE') {
        dispatch(setDeliveryApprovaldData([]));
        if (callback) {
          callback([]);
        }
      }
    },
    failureCb: res => {
      dispatch(setIsFetchingDeliveryApprovalData(false));
      dispatch(setDeliveryApprovaldData([]));
      if (callback) {
        callback([]);
      }
    },
    catchCb: res => {
      dispatch(setIsFetchingDeliveryApprovalData(false));
      dispatch(setDeliveryApprovaldData([]));
      if (callback) {
        callback([]);
      }
    }
  };

  makeApiCall(requestObj);
};
